function setFavicons (favImg) {
    let headTitle = document.querySelector('head')
    let setFavicon = document.createElement('link')
    setFavicon.setAttribute('rel', 'shortcut icon')
    setFavicon.setAttribute('href', favImg)
    headTitle.appendChild(setFavicon)
}

export default setFavicons
